import { render, staticRenderFns } from "./xianbingshi.vue?vue&type=template&id=21745272&"
import script from "./xianbingshi.vue?vue&type=script&lang=ts&"
export * from "./xianbingshi.vue?vue&type=script&lang=ts&"
import style0 from "./xianbingshi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports